export default __webpack_public_path__ + "static/media/inbound.158ebf0d.svg";